// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  getPermissionTable ({commit, state}, params) {
    let promised = request.alert('getPermissionTable', params)
    return promised
  },
  getPermissionGroupTable ({commit, state}, params) {
    let promised = request.alert('getPermissionGroupTable', params)
    return promised
  },
  getPermissionGroupDetail ({commit, state}, params) {
    let promised = request.alert('getPermissionGroupDetail', params)
    return promised
  },
  exportPermissionGroupData ({commit, state}, params) {
    let promised = request.alert('exportPermissionGroupData', params)
    return promised
  },
  createPermissionGroupData ({commit, state}, params) {
    let promised = request.alert('createPermissionGroupData', params)
    return promised
  },
  updatePermissionGroupData ({commit, state}, params) {
    let promised = request.alert('updatePermissionGroupData', params)
    return promised
  },
  deletePermissionGroupData ({commit, state}, params) {
    let promised = request.alert('deletePermissionGroupData', params)
    return promised
  },
  savePermissionGroupData ({commit, state}, params) {
    let promised = request.alert('savePermissionGroupData', params)
    return promised
  },
}

// mutations
const mutations = {}

export const permissionGroup = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/permission-group/permission-group.store.js